// extracted by mini-css-extract-plugin
export var container = "_sj-0";
export var dotAnimation = "_sj-2";
export var dotsLoading = "_sj-1";